<template>
    <div class="page-bg login">
    
        <v-container fill-height justify-center>
    
            <div class="login-block">
    
                <div class="Client-logo">
    
                    <img :src="logo" class="Client-logo-img" />
    
                </div>
    
                <v-form class="login-frm">
    
                    <v-row>
    
                        <v-col cols="12" sm="12" class="pad-zero">
    
                            <v-text-field v-model="emailid" label="Email ID/ User ID" dense outlined></v-text-field>
    
                        </v-col>
    
                        <v-col cols="12" sm="12" class="pad-zero">
    
                            <div class="radio-inline-cls">
    
                            </div>
    
                        </v-col>
    
    
    
                        <v-col cols="12" sm="12" class="pad-zero">
    
                            <div class="signup-primary top-0">
    
                                <div class="user-new-signup"> </div>
    
                                <div class="sign-up-btn">
    
                                    <v-btn :loading="loading" @click="onGoClick" class="right-btn cust-btn" color="primary">Go</v-btn>
    
                                </div>
    
                            </div>
    
                        </v-col>
    
                    </v-row>
    
                </v-form>
                <div v-if="isDefaultInstitute && myInstitute && !myInstitute.is_white_labeled" class="power-logo">
    
                    <img src="@/assets/img/logo-footer.png" class="master-logo" />
    
                </div>
    
            </div>
    
        </v-container>
    
    
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
    name: 'sendotp',
    data() {
        return {
            loading: false,
            logo: this.getInstituteLogo(),
            emailid:'',
        }
    },
    methods: {
        ...mapActions({
            forgotPassword: "userStore/forgotPassword"
        }),
        onGoClick() {
          
            // Password reset is EMAIL-ONLY (client decision, Aug 2026) — the
            // Mobile/OTP option was removed; see the backend forgotPassword.
            if (!this.emailid) {
                this.$toasted.error("Enter Valid email Id or user Id ", { icon: 'info' });
            } else {
                this.loading = true;
                this.forgotPassword({ email: this.emailid, mode: 'email' }).then(response => {
                        this.loading = false;
                        this.$toasted.success(`Success\n${response.msg}`, { icon: 'check_circle' });
                        this.$router.push({ name: "login" }).catch(() => {});
                    })
                    .catch(err => {
                        this.loading = false;
                    });
            }

        },
    },
    computed: {
		...mapState('userStore', ['isDefaultInstitute','myInstitute']),
	}
}
</script>
